import { patientStudiesClient } from '@/api/patients/patientStudiesClient';
import { QueryKey } from '@/data/query';

interface PatientStudiesPageParams {
  size: number;
  after?: string;
  before?: string;
}
const queryClient = patientStudiesClient();

export const useGetPatientStudies = (pageParams: PatientStudiesPageParams, patientId: number) => {
  const queryResult = queryClient.listPatientStudies.useQuery({
    queryKey: [QueryKey.GetPatientStudies, pageParams, patientId],
    queryData: {
      params: { id: patientId },
      query: { page: pageParams }
    },
    enabled: Boolean(patientId)
  });
  return {
    data: queryResult.data?.body ?? null,
    isError: queryResult.isError,
    isLoading: queryResult.isLoading,
    refetch: queryResult.refetch
  };
};
